import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { TelephonyServiceProviderConfiguration } from '../../extViewmodels/sdk/models/Telephony';
import { refetchTelephonyConfiguration } from './useTelephonyConfigurationQuery';

export function useTelephonyComplianceReviewOverrideMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (configuration?: TelephonyServiceProviderConfiguration) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		// The endpoint is impersonation-only: it exists solely on the admin controller under
		// impersonate/{accountId}/admin/telephony/...
		mutationFn: (params: { impersonationContext?: Api.IImpersonationContext; reason: string }) => {
			return userSession.webServiceHelper.callAsync<void>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'admin/telephony/config/complianceReview/override',
					impersonationContext: params.impersonationContext,
				}),
				'POST',
				{ reason: params.reason }
			);
		},
		onError,
		// Pending until the refetch lands, so the panel never shows a deactivated campaign awaiting its successor.
		onSuccess: async (_, { impersonationContext }) => {
			onSuccess?.(await refetchTelephonyConfiguration(impersonationContext));
		},
	});
}
